import { render, staticRenderFns } from "./AddressInput.vue?vue&type=template&id=0b891d2b"
import script from "./AddressInput.vue?vue&type=script&lang=ts"
export * from "./AddressInput.vue?vue&type=script&lang=ts"
import style0 from "./AddressInput.vue?vue&type=style&index=0&id=0b891d2b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports